import React, { type ReactElement } from 'react';

import Image from 'next/image';

import classNames from 'classnames';

import Text from '@/common/components/text/text.component';

export interface EmptyStateProps {
  iconSrc: string;
  message: string;
  className?: string;
}

export default function EmptyState({
  iconSrc,
  message,
  className,
}: EmptyStateProps): ReactElement {
  return (
    <div
      className={classNames(
        'fixed right-0 top-0 -z-50 flex h-full w-full flex-col  items-center justify-center gap-y-6',
        className
      )}
    >
      <div className="justify-center ">
        <Image
          src={iconSrc}
          alt={message || 'حالت خالی'}
          width={200}
          height={200}
          style={{ width: 'auto', height: 'auto' }}
        />
      </div>

      <Text className="text-sm font-medium text-black-200">{message}</Text>
    </div>
  );
}
